import {DG_Format_Money} from "../../../../format/money";
import React from "react";

const styleColor3 = {
    color: "#101828",
    fontWeight: 600,
    marginRight: 5
}

const styleColor = {
    color: "#98A2B3",
    fontsize: 16,
    fontWeight: 400
}
export const mapMoney = (value) => {

    let money = value / 1000000000
    if (money > 1) {
        return (
            <>
                    <span style={{
                        ...styleColor3,
                        fontSize: 30
                    }}> {DG_Format_Money(money)} </span>
                <span style={styleColor}> (Tỷ VNĐ) </span>
            </>
        )
    } else {
        money = value / 1000000
        if (money > 1) {
            return (
                <>
                        <span style={{
                            ...styleColor3,
                            fontSize: 30
                        }}> {DG_Format_Money(money)} </span>
                    <span style={styleColor}> (Triệu VNĐ) </span>
                </>
            )
        }
    }

    return (
        <>
                <span style={{
                    ...styleColor3,
                    fontSize: 30
                }}> {DG_Format_Money(value)} </span>
            <span style={styleColor}> (VNĐ) </span>
        </>
    )

}
